<template>
  <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6" />
  <path d="M12 7v5l3 2" stroke="currentColor" stroke-width="1.6" />
</template>
